

var Settings = function () {
    this.defaultBlock = 'latest';
    this.defaultAccount = undefined;
};

module.exports = Settings;




//////////////////
// WEBPACK FOOTER
// ./node_modules/web3/lib/web3/settings.js
// module id = 183
// module chunks = 0